import { useLocation, useNavigate } from 'react-router-dom';

import mainBanner from '@/assets/img/banner/info.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import TabList from '@/components/common/Tab/TabList/TabList';
import SponsorshipAnnualDonation from '@/components/Sponsorship/SponsorshipAnnualDonation';
import SponsorshipGuide from '@/components/Sponsorship/SponsorshipGuide';
import { SPONSORSHIP_MENU_LIST } from '@/constants/sponsorship';

const menuList = [...SPONSORSHIP_MENU_LIST];

const Sponsorship = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const params = location.state?.menu ?? menuList[0];

	const handleSetMenu = (menu: string) => {
		navigate('/sponsorship', { state: { menu } });
	};

	return (
		<main>
			<SubBanner subTitle="Sponsorship" title="후원안내" img={mainBanner} />
			<TabList menuList={menuList} menuKey={params} onListClick={handleSetMenu} />
			{params === menuList[0] && <SponsorshipGuide />}
			{params === menuList[1] && <SponsorshipAnnualDonation />}
		</main>
	);
};

export default Sponsorship;
